import { createReducer, on } from '@ngrx/store';

import { IEventState } from '@shared/types/event';

import {
    event_selection_from_portal,
    get_events,
    get_events_failure,
    get_events_success,
    reset_events,
    update_event_selection,
    update_event_selection_failure,
    update_event_selection_success,
} from '../actions/events.action';
import { set_iframe_mode } from '../actions/session.action';

const initialState: IEventState = {
    events: [],
    eventsOrderDateRange: {},
    selectedEvents: [],
    selectedEvent: null,
    selectedEventsReportId: null,
    enablePicker: false,
    iframePostMessageResult: null,
    isReady: false,
    eventsLoaded: false,
    originalEventPeriodData: [],
};

const _eventsReducer = createReducer(
    initialState,

    on(get_events, (state): IEventState => {
        return {
            ...state,
            isReady: false,
        };
    }),
    on(get_events_success, (state, { events, eventsOrderDateRange, originalEventPeriodData }): IEventState => {
        return {
            ...state,
            events,
            isReady: true,
            eventsLoaded: true,
            eventsOrderDateRange,
            originalEventPeriodData,
        };
    }),
    on(get_events_failure, (state): IEventState => ({ ...state, events: [] })),

    on(event_selection_from_portal, (state, { payload }): IEventState => {
        const isMultiple = payload.isMultiple;
        const events = payload.payload.items.map((event) => {
            const { order_start_date, order_end_date } = state.eventsOrderDateRange[event.id] || {};
            const matchedEvent = state.events.find((e) => e.id === event.id) || event;

            return {
                ...matchedEvent,
                order_dates: order_start_date ? [order_start_date, order_end_date] : [],
            };
        });
        return {
            ...state,
            [isMultiple ? 'selectedEvents' : 'selectedEvent']: isMultiple ? events : events[0],
        };
    }),
    on(set_iframe_mode, (state, { isIframeMode }): IEventState => ({ ...state, enablePicker: isIframeMode })),

    on(update_event_selection, (state): IEventState => state),
    on(update_event_selection_success, (state, { isMultiple, events, reportId }): IEventState => {
        return {
            ...state,
            [isMultiple ? 'selectedEvents' : 'selectedEvent']: isMultiple ? events : events[0],
            selectedEventsReportId: reportId,
        };
    }),

    on(update_event_selection_failure, (state): IEventState => state),
    on(
        reset_events,
        (state): IEventState => ({
            ...state,
            selectedEvents: [],
            selectedEvent: null,
        }),
    ),
);

export function eventsReducer(state, action) {
    return _eventsReducer(state, action);
}
